module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4e0d75550eca72a2eb76932cbd2cf0c2.gif";